// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestPendingSetupSaveBody = {
  poolId: string;
  name: string;
  config: {
    startDate: string;
    roundGrouping: "day" | "week";
    weekStartDay?: number | null;
    roundLockTiming?: "firstGame" | "lastGame";
    pickBasis: "moneyline" | "spread";
    spreadTiming?: "lockedEarly" | "live" | null;
    advanceCriterion: "winAll" | "winHalfOrMore";
    livesAllowed?: number;
    requiredPicksPerRound: number;
    maxEntriesPerMember: number;
    teamReuseAllowed: boolean;
    teamReuseLockoutDays?: number | null;
    teamReuseMaxCount?: number | null;
    revivesAllowed: "unlimited" | "limited";
    revivesAllowedCount?: number | null;
    postponementPolicy: "makeUpNextRound" | "countAsLoss";
    tiePolicy: "tieIsWin" | "tieIsLoss";
    tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
    winPoints: number;
    lossPoints: number;
    skipsAllowed?: boolean;
    skipsMaxPerContest?: number | null;
    endDate?: string | null;
    endDateMode?: "date" | "tbd" | null;
    pickSchedule?: {
      version: 1;
      requirements: {
        requirementId: string;
        startsOn: string;
        endsOn: string | null;
        timeZone: string;
        cadence: "day" | "week";
        weekStartDay: number | null;
        requiredPicks: number;
        revivedRequiredPicks: number | null;
        lockTiming: "firstGame" | "lastGame";
        teamReuseAllowed: boolean;
        inheritPreviousReuse: boolean;
        extendPreviousGames: boolean;
        postponementPolicy: "makeUpNextRound" | "countAsLoss";
      }[];
    } | null;
    spreadPolicy?: "automatic72h";
  };
};

export type typeContestPendingSetupSaveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { savedAt: string };
};

export type typeContestPendingSetupSaveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingSetupSaveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingSetupSaveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestPendingSetupSaveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    name: { type: "string", maxLength: 3000, minLength: 1 },
    config: {
      type: "object",
      properties: {
        startDate: { type: "string", maxLength: 3000, minLength: 1 },
        roundGrouping: { type: "string", enum: ["day", "week"] },
        weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        roundLockTiming: {
          description:
            "Defaults to lastGame for new configuration when omitted. Explicit firstGame remains supported.",
          type: "string",
          enum: ["firstGame", "lastGame"],
        },
        pickBasis: { type: "string", enum: ["moneyline", "spread"] },
        spreadTiming: {
          oneOf: [
            { type: "string", enum: ["lockedEarly", "live"] },
            { enum: [null] },
          ],
        },
        advanceCriterion: { type: "string", enum: ["winAll", "winHalfOrMore"] },
        livesAllowed: {
          deprecated: true,
          description:
            "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
          type: "integer",
        },
        requiredPicksPerRound: { type: "integer" },
        maxEntriesPerMember: { type: "integer" },
        teamReuseAllowed: { type: "boolean" },
        teamReuseLockoutDays: {
          oneOf: [{ type: "integer" }, { enum: [null] }],
        },
        teamReuseMaxCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        revivesAllowed: { type: "string", enum: ["unlimited", "limited"] },
        revivesAllowedCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        postponementPolicy: {
          type: "string",
          enum: ["makeUpNextRound", "countAsLoss"],
        },
        tiePolicy: { type: "string", enum: ["tieIsWin", "tieIsLoss"] },
        tiebreaker: {
          type: "string",
          enum: ["splitMedal", "noWinner", "commissionerPick"],
        },
        winPoints: { type: "integer" },
        lossPoints: { type: "integer" },
        skipsAllowed: {
          deprecated: true,
          description:
            "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
          type: "boolean",
        },
        skipsMaxPerContest: {
          oneOf: [{ type: "integer" }, { enum: [null] }],
          deprecated: true,
          description:
            "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
        },
        endDate: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        endDateMode: {
          oneOf: [{ type: "string", enum: ["date", "tbd"] }, { enum: [null] }],
        },
        pickSchedule: {
          oneOf: [
            {
              type: "object",
              properties: {
                version: { type: "integer", enum: [1] },
                requirements: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      requirementId: { type: "string" },
                      startsOn: { type: "string" },
                      endsOn: { oneOf: [{ type: "string" }, { enum: [null] }] },
                      timeZone: { type: "string" },
                      cadence: { type: "string", enum: ["day", "week"] },
                      weekStartDay: {
                        oneOf: [{ type: "integer" }, { enum: [null] }],
                      },
                      requiredPicks: { type: "integer" },
                      revivedRequiredPicks: {
                        oneOf: [{ type: "integer" }, { enum: [null] }],
                      },
                      lockTiming: {
                        type: "string",
                        enum: ["firstGame", "lastGame"],
                      },
                      teamReuseAllowed: { type: "boolean" },
                      inheritPreviousReuse: { type: "boolean" },
                      extendPreviousGames: { type: "boolean" },
                      postponementPolicy: {
                        type: "string",
                        enum: ["makeUpNextRound", "countAsLoss"],
                      },
                    },
                    required: [
                      "requirementId",
                      "startsOn",
                      "endsOn",
                      "timeZone",
                      "cadence",
                      "weekStartDay",
                      "requiredPicks",
                      "revivedRequiredPicks",
                      "lockTiming",
                      "teamReuseAllowed",
                      "inheritPreviousReuse",
                      "extendPreviousGames",
                      "postponementPolicy",
                    ],
                  },
                },
              },
              required: ["version", "requirements"],
            },
            { enum: [null] },
          ],
        },
        spreadPolicy: {
          description:
            "Automatic shared Survivor game spread policy; absent on historical configurations.",
          enum: ["automatic72h"],
        },
      },
      required: [
        "startDate",
        "roundGrouping",
        "pickBasis",
        "advanceCriterion",
        "requiredPicksPerRound",
        "maxEntriesPerMember",
        "teamReuseAllowed",
        "revivesAllowed",
        "postponementPolicy",
        "tiePolicy",
        "tiebreaker",
        "winPoints",
        "lossPoints",
      ],
    },
  },
  required: ["poolId", "name", "config"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestPendingSetupSave(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestPendingSetupSaveBody);
  }

  return async function postContestPendingSetupSave(
    payload: typeContestPendingSetupSaveBody,
  ): Promise<
    typeContestPendingSetupSaveOutput200 | typeContestPendingSetupSaveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestPendingSetupSave" failed before calling the network. #d2debee52c90`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d2debee52c90" },
        },
        data: null,
      } as typeContestPendingSetupSaveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/pending-setup-save`,
      httpMethod: "POST",
      options,
    })) as
      | typeContestPendingSetupSaveOutput200
      | typeContestPendingSetupSaveOutput400;
  };
}
